/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sort_AzInputs */

const en_dashboard_sort_az = /** @type {(inputs: Dashboard_Sort_AzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

const es_dashboard_sort_az = /** @type {(inputs: Dashboard_Sort_AzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A–Z`)
};

/**
* | output |
* | --- |
* | "A–Z" |
*
* @param {Dashboard_Sort_AzInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_sort_az = /** @type {((inputs?: Dashboard_Sort_AzInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sort_AzInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_sort_az(inputs)
	return en_dashboard_sort_az(inputs)
});